/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatrixCareHomeHealthCreatePatientInput } from './MatrixCareHomeHealthCreatePatientInput';
import {
    MatrixCareHomeHealthCreatePatientInputFromJSON,
    MatrixCareHomeHealthCreatePatientInputFromJSONTyped,
    MatrixCareHomeHealthCreatePatientInputToJSON,
    MatrixCareHomeHealthCreatePatientInputToJSONTyped,
} from './MatrixCareHomeHealthCreatePatientInput';

/**
 * 
 * @export
 * @interface CreateMatrixCareHomeHealthPatientRequest
 */
export interface CreateMatrixCareHomeHealthPatientRequest {
    /**
     * 
     * @type {MatrixCareHomeHealthCreatePatientInput}
     * @memberof CreateMatrixCareHomeHealthPatientRequest
     */
    patient: MatrixCareHomeHealthCreatePatientInput;
}

/**
 * Check if a given object implements the CreateMatrixCareHomeHealthPatientRequest interface.
 */
export function instanceOfCreateMatrixCareHomeHealthPatientRequest(value: object): value is CreateMatrixCareHomeHealthPatientRequest {
    if (!('patient' in value) || value['patient'] === undefined) return false;
    return true;
}

export function CreateMatrixCareHomeHealthPatientRequestFromJSON(json: any): CreateMatrixCareHomeHealthPatientRequest {
    return CreateMatrixCareHomeHealthPatientRequestFromJSONTyped(json, false);
}

export function CreateMatrixCareHomeHealthPatientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMatrixCareHomeHealthPatientRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'patient': MatrixCareHomeHealthCreatePatientInputFromJSON(json['patient']),
    };
}

export function CreateMatrixCareHomeHealthPatientRequestToJSON(json: any): CreateMatrixCareHomeHealthPatientRequest {
    return CreateMatrixCareHomeHealthPatientRequestToJSONTyped(json, false);
}

export function CreateMatrixCareHomeHealthPatientRequestToJSONTyped(value?: CreateMatrixCareHomeHealthPatientRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient': MatrixCareHomeHealthCreatePatientInputToJSON(value['patient']),
    };
}

